<div class="tabs">
  <nav
    mat-tab-nav-bar
    class="themed-tab-nav">
    <a
      mat-tab-link
      *ngFor="let tab of tabs"
      (click)="switchTab(tab.value)"
      [active]="(tabParam$ | async) == tab.value"
      [attr.data-cy]="'tab-' + tab.value">
      <mat-icon
        [svgIcon]="tab.svgIcon"
        class="size-20"></mat-icon>
      {{ tab.label | i18n | titlecase }}
    </a>
  </nav>
</div>
<app-date-range-select
  class="date-range-select"
  [chips]="dateRangeChips"
  useQueryParam="range"
  subscribeParams
  data-cy="date-range-select"></app-date-range-select>
<mat-form-field class="light-form-field">
  <mat-label>{{ ("search" | i18n) || "Suchen..." | titlecase }}</mat-label>
  <input
    matInput
    [ngModel]="searchParam$ | async"
    (ngModelChange)="mergeQueryParams({ searchText: $event })"
    name="searchText"
    data-cy="employment-search-input" />
  <button
    mat-button
    matSuffix
    mat-icon-button
    aria-label="Search"
    (click)="$event.stopPropagation()">
    <mat-icon svgIcon="magnify"></mat-icon>
  </button>
</mat-form-field>
<div class="flex justify-end filter-row">
  <button
    mat-button
    class="save-filter-button"
    (click)="saveDefaultFilter()"
    data-cy="save-filter-button">
    {{ ("saveDefaultFilter" | i18n) || "Filter als Standard speichern" }}
  </button>
</div>
<div
  *ngIf="currentUser$ | async as currentUser"
  data-cy="pooler-employments-list">
  <app-pooler-employment-list-item
    *ngFor="let employment of employments$ | async; trackBy: trackById"
    [employment]="employment"
    [currentUser]="currentUser">
  </app-pooler-employment-list-item>
</div>
